import React from 'react'
import { Card, Typography, Box } from '@mui/material'
import CheckMark from '.././../../../assets/CCImages/check.png'
import NotAvailable from '.././../../../assets/CCImages/cancel.png'
import { useSelector } from 'react-redux'
import { useTheme, useMediaQuery } from '@material-ui/core'

const ComparisonValue = ({ value }) => {
  if (typeof value === 'boolean') {
    return value ? (
      <img width={16} src={CheckMark} alt='Available' />
    ) : (
      <img width={12} src={NotAvailable} alt='Not Available' />
    )
  }

  if (typeof value === 'undefined') {
    return <img width={12} src={NotAvailable} alt='Not Available' />
  }

  if (Array.isArray(value)) {
    return (
      <>
        {value.map((item, idx) => (
          <div key={idx}>{item?.label || ''}</div>
        ))}
      </>
    )
  }

  if (typeof value === 'string') {
    return value
  }

  return null
}

const ComparisonSection = ({ title, data }) => {
  const { comparison } = useSelector((state) => state.comparison)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Card style={{ paddingBottom: '2rem', margin: '2rem 0' }}>
      <Typography
        style={{ paddingLeft: '1rem', paddingTop: '1.5rem' }}
        color={'#275DA6'}
        fontSize={isMobile ? 20 : 24}
        fontWeight={700}
      >
        {title}
      </Typography>

      <hr />

      <Box
        sx={{
          overflowX: 'auto',
          '&::-webkit-scrollbar': {
            height: '4px'
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: '#f0f0f0'
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#005FAA',
            borderRadius: '4px'
          }
        }}
      >
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: `repeat(${comparison.length + 1}, minmax(120px, 1fr))`,
            minWidth: isMobile ? `${120 * (comparison.length + 1)}px` : 'auto'
          }}
        >
          {data.map((item, idx) => (
            <React.Fragment key={idx}>
              <div style={{ textAlign: item.title === 'Compare Features' ? 'initial' : 'center' }}>
                <Typography
                  sx={{
                    padding: '1rem',
                    textAlign: 'center',
                    minHeight: '40px',
                    backgroundColor: idx % 2 ? '#F4F4F4' : '#fff'
                  }}
                  color={'#868686'}
                  fontSize={12}
                >
                  {item.title}
                </Typography>
              </div>
              {item.values?.map((value, idy) => (
                <div style={{ textAlign: 'center' }} key={idy}>
                  <Typography
                    sx={{
                      padding: '1rem',
                      textAlign: 'center',
                      minHeight: '40px',
                      backgroundColor: idx % 2 ? '#F4F4F4' : '#fff'
                    }}
                    color={'#868686'}
                    fontSize={12}
                  >
                    <ComparisonValue value={value} />
                  </Typography>
                </div>
              ))}
            </React.Fragment>
          ))}
        </Box>
      </Box>
    </Card>
  )
}

export default ComparisonSection
